"use client";

import { Ingredient } from "../../../__generated__/contentful-types";
import { helpers } from "@contentful/rich-text-types";
import { CosmosIconChevronDown } from "@cosmos/web-react";
import classNames from "classnames/bind";
import { useState } from "react";
import styles from "./dropdown-list.module.css";

const cx = classNames.bind(styles);

export const DropdownList = ({ items }: { items: Ingredient[] }) => {
  return (
    <ul role="list" className={cx("container")}>
      {items.map((item, index) => (
        <ListItem item={item} key={index} />
      ))}
    </ul>
  );
};

const ListItem = ({ item }: { item: Ingredient }) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  return (
    <li
      className={cx("item", {
        "item--active": isActive,
      })}
    >
      <button
        className={cx("item-label")}
        onClick={() => setIsActive((current) => !current)}
        aria-expanded={isActive ? "true" : "false"}
        aria-controls={item.sys.id}
      >
        <CosmosIconChevronDown
          className={cx("item-label-icon")}
          aria-hidden="true"
        />
        {item.title}
      </button>
      {item.teaserText && (
        <div id={item.sys.id} className={cx("item-content")} hidden={!isActive}>
          <div className={cx("item-content-inner")}>
            <p>
              {
                item.teaserText.json.content[0].content.filter(
                  helpers.isText,
                )[0].value
              }
            </p>
          </div>
        </div>
      )}
    </li>
  );
};
